interface KeyValueObject {
  [key: string]: string
}

export function updateStringObject(string: string | undefined, key: string, new_value: string): string {
  const new_string = `${key}:${new_value};`
  if (!string) return new_string

  if (!string.includes(key)) {
    return `${string}${new_string}`
  }
  else {
    // const deduped_string = objectToString(stringToObject(string))
    const deduped_string = string

    const regex = new RegExp(`(${key}:)[^;]+`)
    const new_string = deduped_string.replace(regex, `$1${new_value}`)

    return new_string
  }
}

export function updateStringList(string: string | undefined, new_value: string, add: boolean) {
  const item = `${new_value};`
  if (typeof string === 'string') {
    if (add) {
      return string.includes(item) ? string : `${string}${item}`.replaceAll('x;', '')
    }
    else {
      const temp = string.replaceAll(item, '')
      if (temp === '') return 'x;'
      else return temp
    }
  }
  else {
    return add ? item : ''
  }
}

export function stringListToArray(string: string | undefined): string[] {
  if (!string) return []

  return string.split(';').filter(item => item.trim() !== '')
}

export function stringToObject(string: string | undefined): KeyValueObject {
  if (!string) return {}

  const pairs = string.split(';')
  const obj: KeyValueObject = {}

  pairs.forEach((pair: string) => {
    const [key, value] = pair.split(':')
    if (key && value) {
      obj[key] = value
    }
  })

  return obj
}

export function objectToString(obj: KeyValueObject): string {
  if (Object.keys(obj).length === 0) return ''
  return Object.entries(obj)
    .map(([key, value]) => `${key}:${value}`)
    .join(';') + ';'
}

export function readString(string: string | undefined, key: string) {
  if (!string) return undefined
  // Find the key-value pair using a regular expression
  const match = string.match(new RegExp(`${key}:([^;]+);`))

  // Return the value if found, or null if not
  return match ? match[1] : null
}
